import api from '@/api/api';
import { IAccountInfo, IMyProfile, IProfilePicture } from '@/models/account';
import { IResponseData, ResultDatas } from '@/models/common';
import { AxiosResponse } from 'axios';
import { ApiAccounts } from '.';
import getApiResponse from '@/api/apiResponse';

export const AccountsService = {
  /**
   *
   * @return 마이페이지에서 설정한 약국키
   */
  async getMyDefaultPharmacyKey() {
    const res: AxiosResponse<IResponseData<Number>> = await api.get(ApiAccounts.GET_DEFAULT_PHARMACYKEY);
    return getApiResponse<Number>(res);
  },

  /***
   * return userinfo
   * @returns {IMyProfile} IMyProfile
   */
  async getMyProfile() {
    const res: AxiosResponse<IResponseData<IMyProfile>> = await api.get(ApiAccounts.USER_PROFILE);
    const profile = getApiResponse<IMyProfile>(res);

    profile.ReceiveEmail = !!profile?.ReceiveEmail;
    profile.ReceiveSms = !!profile?.ReceiveSms;

    const { BirthDate, PhoneNumber, Sex } = profile;
    if (!(BirthDate && PhoneNumber && Sex)) {
      return profile;
    } else {
      if (profile.BirthDate.length === 8) {
        profile.BirthDate =
          profile.BirthDate.substring(0, 4) +
          '/' +
          profile.BirthDate.substring(4, 6) +
          '/' +
          profile.BirthDate.substring(6, 8);
      }
    }
    return profile;
  },

  /**
   *
   * @return 마이페이지에서 설정한 약국키
   */
  async getMyPicture() {
    const res: AxiosResponse<IResponseData<IProfilePicture>> = await api.get(ApiAccounts.GET_PROFILE_PICTURE);
    return getApiResponse<IProfilePicture>(res);
  },

  /***
   * 로그인 후 기본 정보
    uid
    userName
    role
    name
    pid
    isRRN
   */

  /**
   *
   * @returns {IAccountInfo} uid, userNmae, role, name, pid, isRRN
   */
  async getAccountInfo() {
    try {
      const res: AxiosResponse<IResponseData<any>> = await api.get(ApiAccounts.ACCOUNT_INFO);
      console.log(res, 'getAccountInfo.res');
      return getApiResponse<IAccountInfo>(res);
    } catch (ex) {
      console.log(ex, 'getAccountInfo.ex');
      throw ex;
    }
    //const res: AxiosResponse<IResponseData<IAccountInfo>> = await api.get(ApiAccounts.ACCOUNT_INFO);
  },

  /***
   * @param culture : "en-us", "ja-jp", "ko-kr";
   */
  async setLanguage(culture: string) {
    const params = {
      culture,
    };
    const res: AxiosResponse<IResponseData<string>> = await api.get(ApiAccounts.SET_LANGUAGE, { params });
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  /**
   *
   * @param {IMyProfile} data - my profile
   * @returns 저장 결과
   */
  async saveMyProfileData(data: IMyProfile) {
    data.ReceiveEmail = data.ReceiveEmail ? 1 : 0;
    data.ReceiveSms = data.ReceiveSms ? 1 : 0;
    //data.PharmacyKey = data.PharmacyKey ?? 0;

    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiAccounts.SAVE_MY_PROFILE, data);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  /**
   *
   * @param {String} rrn 주민등록번호
   * @returns 주민등록번호 등록 결과
   */
  async setResidentRegNumber(rrn: string) {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiAccounts.SAVE_RRN, { rrn });
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
};

export default AccountsService;
